<template>
    <div v-bind="$attrs">
        <apex-charts type="donut" :height="height" :width="width" :options="chartOptions" :series="series"></apex-charts>

        <slot name="content"></slot>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { colors } from '@/Composables/ChartColors';

export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },

        height: {
            type: String,
            default: '100%',
        },

        width: {
            type: String,
            default: '100%',
        },

        series: {
            type: Array,
            required: true,
        },

        labels: {
            type: Array,
            required: true,
        },
    },

    computed: {
        chartOptions() {
            return {
                noData: {
                    text: i18n.t('charts.noData'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined,
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false,
                            },
                        },
                    },
                },

                chart: {
                    toolbar: {
                        show: true,
                    },

                    width: this.width,
                },

                labels: this.labels,

                dataLabels: {
                    enabled: false,
                },

                colors: colors,

                legend: {
                    show: true,
                    position: 'bottom',
                    width: '100%',
                },

                tooltip: {
                    y: {
                        title: {
                            // Hide the series name as we won't need it.
                            // formatter: (seriesName) => {
                            formatter: () => {
                                return '';
                            },
                        },
                    },
                },

                stroke: {
                    curve: this.curve,
                },

                ...this.options,
            };
        },
    },
};
</script>

<style></style>
